import { Container, Row, Col } from "react-bootstrap";
import Card from "@Admin/components/Card";
import ListUsers from "./listUsers";

const Users = () =>
<div className="content">
  <Container fluid>
    <Row>
      <Col md={12}>
        <Card title={'Users'}>
          <ListUsers />
        </Card>
      </Col>
    </Row>
  </Container>
</div>

export default Users;